import { render, staticRenderFns } from "./CasinoReviewForm.vue?vue&type=template&id=390ecfea&"
import script from "./CasinoReviewForm.vue?vue&type=script&lang=js&"
export * from "./CasinoReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports